var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DislikeFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDislikeFilled extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon-dislike-filled', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.00543 2.38221C8.53339 2.13057 9.11086 2 9.6957 2L18.0967 2C20.0321 2 21.6791 3.40958 21.9782 5.32178L22.9616 11.6126C23.2597 13.5188 21.7858 15.2409 19.8564 15.2409H14.6963V18.9457C14.6963 20.3562 13.5529 21.4998 12.1423 21.4998C11.2179 21.4998 10.3656 21.0002 9.91391 20.1936L6.64951 14.3634C6.45251 14.0115 6.34906 13.615 6.34906 13.2118L6.34905 4.6594C6.34905 3.75053 6.87158 2.92262 7.69204 2.53157L8.00543 2.38221ZM2.56571 14.0755C2.15046 14.0755 1.75221 13.9105 1.45858 13.6169C1.16496 13.3232 1 12.925 1 12.5097L1 4.47561C1 4.06035 1.16496 3.66211 1.45858 3.36848C1.75221 3.07485 2.15045 2.90989 2.56571 2.90989L3.34602 2.91024C3.77983 2.91041 4.13141 3.26215 4.13141 3.69596V13.2901C4.13141 13.4985 4.04858 13.6984 3.90116 13.8458C3.75373 13.9931 3.5538 14.0759 3.34535 14.0758L2.56571 14.0755Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconDislikeFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDislikeFilled.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconDislikeFilled.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconDislikeFilled.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-dislike-filled') === undefined) {
    customElements.define('cat-icon-dislike-filled', BlocksIconDislikeFilled);
}
